<template>
  <div v-if="_visible" class="versionManage">
    <div v-show="versionView" class="versionManage-main">
      <module-title title="版本管理">
        <div class="right">
          <el-button
            type="primary"
            size="medium"
            icon="el-icon-plus"
            @click="opAddOrEdit('add')"
          >
            添加版本
          </el-button>
          <el-button type="primary" size="medium" icon="el-icon-arrow-left" @click="back">
            返回
          </el-button>
        </div>
      </module-title>
      <div class="versionManage-main-contain">
        <el-table
          v-loading="listLoading"
          :data="versionManage"
          highlight-current-row
          fit
          element-loading-text="Loading"
          class="list-table"
        >
          <el-table-column type="index" width="55" align="center" label="序号" />
          <el-table-column label="应用名称" prop="appName" align="center" />
          <el-table-column label="包名" prop="packageName" align="center" show-overflow-tooltip />
          <el-table-column label="版本号" prop="editionNo" align="center" width="100" />
          <el-table-column label="升级描述" prop="introduction" align="center" show-overflow-tooltip />
          <el-table-column label="状态" align="center" width="100">
            <template slot-scope="scope">
              {{ scope.row.status == '1' ?'启用':'禁用' }}
            </template>
          </el-table-column>
          <el-table-column label="发布时间" prop="updateDate" align="center" width="128">
            <template slot-scope="scope">
              {{ formatTimeToStr(scope.row.updateDate) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="300px">
            <template slot-scope="scope">
              <el-button
                v-show="scope.row.status == '-1'"
                type="success"
                size="small"
                icon="el-icon-success"
                style="margin-left:10px"
                @click="handleVersionEnable(scope.row)"
              >
                启用
              </el-button>
              <el-button
                v-show="scope.row.status == '1'"
                type="warning"
                size="small"
                icon="el-icon-warning-outline"
                @click="handleVersionDisable(scope.row)"
              >
                禁用
              </el-button>
              <el-button
                type="primary"
                size="small"
                icon="el-icon-edit"
                @click="opAddOrEdit('edit',scope.row)"
              >
                编辑
              </el-button>
              <el-button
                type="primary"
                size="small"
                icon="el-icon-edit"
                @click="downApp(scope.row)"
              >
                下载
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :total="searchForm.total"
          :page.sync="searchForm.pageNum"
          :limit.sync="searchForm.pageSize"
          @pagination="pageCurriculumList"
          @handleSizeChange="handleSizeChange"
        />
      </div>
    </div>
    <!-- 新增和编辑版本 -->
    <add-version
      :visible.sync="hiddenVariable.addVersionVisible"
      :handle-type="handleType"
      :update-row="updateRow"
      :app-name="appName"
      :terminal-id="terminalId"
      :apply-terminals="applyTerminals"
      :app-id="searchForm.managementId"
    />
    <el-dialog :visible.sync="dialogImageVisible" title="预览图片">
      <img width="100%" :src="dialogImageUrl" alt>
    </el-dialog>
  </div>
</template>

<script>

import AddVersion from './addVersion';
import { formatTimeToStr } from '@/utils/index';
// import { getToken } from '@/utils/auth';
import {
  versionList,
  versionDisable,
  versionEnable
} from '@/api/productOperation/wisdom/applicationList';
import { mapGetters } from 'vuex';
export default {
  name: 'VersionManage',
  components: {
    AddVersion
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    appId: {
      type: String,
      required: true
    },
    appName: {
      type: String,
      required: true
    },
    terminalId: {
      type: Number,
      required: true
    },
    applyTerminals: {
      type: Array,
      required: false
    }
  },
  data() {
    return {
      versionView: true, // 版本管理页面
      // 弹框标题
      handleType: 'add',
      // 所有控制显示隐藏变量
      hiddenVariable: {
        dialogEditVisible: false, // 学生详情
        // 详情
        dialogDetailVisible: false, // 详情标识
        // 新增版本
        addVersionVisible: false
      },
      // 搜索表单
      searchForm: {
        managementId: '',
        pageNum: 1,
        total: 0,
        pageSize: 10,
        typeCode: 'C15'
      },
      listLoading: false, // 表格刷新loading
      versionManage: [],
      ajaxLoading: false, //  表单提交loading
      dialogImageVisible: false,
      updateRow: {}, // 编辑版本row
      dialogImageUrl: '',
      addVersionForm: {
        apkUrl: '',
        apkPath: '',
        managementId: '',
        fileSize: '',
        productId: '',
        packageName: '',
        md5Value: '',
        versionNumber: '',
        versionName: '',
        versionDesc: '',
        appPictures: []
      },
      appPictures: [], // 编辑  原来的图片列表
      handleRules: {
        packageName: [
          { required: true, message: '包名不能为空', trigger: 'blur' }
        ],
        versionName: [
          { required: true, message: '版本名称不能为空', trigger: 'change' }
        ],
        versionNumber: [
          { required: true, message: '版本号不能为空', trigger: 'change' }
        ]
      }
    };
  },
  computed: {
    _visible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    },
    formatTimeToStr() {
      return formatTimeToStr;
    },
    ...mapGetters(['currentProdeuctId'])
  },
  mounted() {
    this.fetchversionManage();
  },
  methods: {
    // 删除编辑时原来的图片
    deleteEditPictures(index) {
      this.appPictures.splice(index, 1);
    },
    // 返回
    back() {
      this._visible = false;
      this.$parent.fetchApplicationList();
    },
    openView() { // 打开应用页面
      this.versionView = true;
    },
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.fetchversionManage();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.fetchversionManage();
    },
    // 条件查询
    handleSearchFilter() {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = 10;
      this.fetchversionManage();
    },
    // 下载
    downApp(row) {
      window.location.href = row.address;
    },
    // 打开新增编辑弹框
    opAddOrEdit(type, row) {
      this.updateRow = row;
      this.handleType = type;
      this.appPictures = [];
      this.hiddenVariable.addVersionVisible = true;
      this.versionView = false;
    },
    handleVersionDisable(row) {
      this.$confirm(`确定要禁用该应用版本么?`, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(() => {
        return versionDisable(row.id, 'C15');
      }).then(res => {
        this.$notify.success({ title: 'Success', message: `禁用成功`, showClose: false, duration: 2000 });
        this.fetchversionManage();
      }).catch(err => {
        console.log(err);
      });
    },
    handleVersionEnable(row) {
      this.$confirm(`确定要启用该应用版本么?`, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(() => {
        return versionEnable(row.id, 'C15');
      }).then(res => {
        this.$notify.success({ title: 'Success', message: `启用成功`, showClose: false, duration: 2000 });
        this.fetchversionManage();
      }).catch(err => {
        console.log(err);
      });
    },
    // 获取版本列表
    fetchversionManage() {
      this.listLoading = true;
      this.searchForm.managementId = this.appId;
      versionList(this.searchForm)
        .then(result => {
          if (result.data && result.data.list && result.data.list.length) {
            this.versionManage = result.data.list;
            this.searchForm.total = result.data.total;
          } else {
            this.versionManage = [];
            this.searchForm.total = 0;
          }
          this.listLoading = false;
        })
        .catch(err => {
          console.log(err);
          this.listLoading = false;
          this.versionManage = [];
          this.searchForm.total = 0;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.versionManage {
  padding-bottom: 20px;
}
.handle-form-input {
  width: 300px;
}
.handle-form-textarea {
  width: 400px;
}
.eidt-pictures {
  float: left;
  .eidt-pictures-item {
    display: inline-block;
    position: relative;
    img {
      width: 148px;
      height: 148px;
      margin-right: 10px;
      border-radius: 6px;
      cursor: pointer;
    }
    .el-icon-error {
      position: absolute;
      top: 0;
      right: 10px;
      cursor: pointer;
      font-size: 16px;
      color: #f56c6c;
    }
  }
}
.el-upload-picture {
  float: left;
}
</style>
